const n = {
  "en-US": "en",
  "fr-FR": "fr",
  "de-DE": "en",
  "es-ES": "en",
  "en-AU": "en",
  "en-CA": "en",
  "en-GB": "en"
}, t = n["en-US"], s = {
  "en-US": "en-us",
  "fr-FR": "fr",
  "de-DE": "en-us",
  "es-ES": "en-us",
  "en-AU": "en-us",
  "en-CA": "en-us",
  "en-GB": "en-us"
}, L = s["en-US"], c = (e) => n[e] ?? t, o = (e) => s[e] ?? L, r = (e, E) => `https://support.peerspace.com/${c(E)}/articles/${e}`;
export {
  n as HELP_CENTER_LOCALE,
  s as ZENDESK_LOCALE,
  c as getHelpCenterLocale,
  r as getSupportArticleUrl,
  o as getZendeskLocale
};
//# sourceMappingURL=index.js.map
